import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import classroomTasks from './main/classroomTasks/classroomTasks'
// Layout 需要加上 .vue 后缀
import Layout from '@/layout/index.vue'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes: RouteRecordRaw[] = [
  //{
    //path: '/:pathMatch(.*)*',
    //name: 'notFound',
    //component: () => import('@/views/not-found/not-found.vue')
  //},
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue'),
        meta: { title: '重定向', noCache: true }
      }
    ]
  } as RouteRecordRaw & { hidden?: boolean },
  {
    path: '/login',
    component: () => import('@/views/login/login.vue'),
    hidden: true
  } as RouteRecordRaw & { hidden?: boolean },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile/index.vue'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  } as RouteRecordRaw & { hidden?: boolean },
  //{
    //path: '/',
    //component: Layout,
    //redirect: '/main',
    //children: [
    //  {
    //    path: 'main',
    //    component: () => import('@/views/main/main.vue'),
    //    name: 'Main',
    //    meta: { title: '主页', icon: 'home' }
  //    }
  //  ]
  //},
  // {
  //   path: '/classroom',
  //   component: Layout,
  //   redirect: '/classroom/index',
  //   meta: {
  //     title: '课堂任务'
  //   },
  //   children: [
  //     classroomTasks
  //   ]
  // },
  {
     path:'/404',
     component: () => import('@/views/not-found/not-found.vue'),
     hidden:true
   } as RouteRecordRaw & { hidden?: boolean },
   // 添加外部链接重定向路由
 
  // 添加专门处理外部链接的路由
  {
    path: '/redirect-to-external/:url',
    name: 'ExternalLink',
    component: {
      render() {
        return null
      },
      beforeCreate() {
        // 获取URL参数
        const { url } = this.$route.params
        if (url) {
          const decodedUrl = decodeURIComponent(url)
          // 打开外部链接
          window.open(decodedUrl, '_blank')
          // 导航回之前的页面
          this.$router.go(-1)
        }
      }
    } as any,
    hidden: true
  } as RouteRecordRaw & { hidden?: boolean }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes: RouteRecordRaw[] = [
  {
    path: '/system/user-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:user:edit'],
    children: [
      {
        path: 'role/:userId(\\d+)',
        component: () => import('@/views/system/user/authRole.vue'),
        name: 'AuthRole',
        meta: { title: '分配角色', activeMenu: '/system/user' }
      }
    ]
  } as RouteRecordRaw & { hidden?: boolean; permissions?: string[] },
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:edit'],
    children: [
      {
        path: 'user/:roleId(\\d+)',
        component: () => import('@/views/system/role/authUser.vue'),
        name: 'AuthUser',
        meta: { title: '分配用户', activeMenu: '/system/role' }
      }
    ]
  } as RouteRecordRaw & { hidden?: boolean; permissions?: string[] }
]


const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior: () => ({ top: 0 })
})

// 防止连续点击多次路由报错
const originalPush = router.push
const originalReplace = router.replace

router.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err)
}

router.replace = function replace(location: any) {
  return originalReplace.call(this, location).catch((err: any) => err)
}

export default router